import useI18n from '@/shared/hooks/usei18n'
import { Trans } from 'react-i18next'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/solid'

export const infoContentComponents = {
  br: <br />,
  ul: <ul className="list-disc pl-4 my-2 space-y-1" />,
  li: <li />,
  strong: <strong className="font-semibold block mt-2 first:mt-0" />
}

export default function InfoDisclosure({
  titleKey,
  contentKey
}: {
  titleKey: string
  contentKey: string
}) {
  const { t } = useI18n()
  return (
    <Disclosure as="div" className="group border border-blue-400 rounded-md overflow-hidden">
      <DisclosureButton className="flex w-full items-center justify-between gap-2 px-3 py-2.5 text-left text-sm font-medium text-blue-500 bg-blue-300 hover:bg-blue-400/30 transition-colors">
        <span>{t(titleKey)}</span>
        <ChevronDownIcon
          className="h-4 w-4 shrink-0 text-blue-500 transition-transform duration-200 group-data-open:rotate-180"
          aria-hidden
        />
      </DisclosureButton>
      <DisclosurePanel>
        <div className="px-3 py-2.5 bg-blue-300 text-sm text-blue-500 border-t border-blue-400 space-y-1">
          <Trans i18nKey={contentKey} components={infoContentComponents} />
        </div>
      </DisclosurePanel>
    </Disclosure>
  )
}
